var _g, _text, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextDrag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79032",
    "data-name": "Group 79032",
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 102,
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226",
    "data-name": "Rectangle 146226",
    fill: "#83ffb9",
    stroke: "#29e67c",
    strokeWidth: 1,
    strokeDasharray: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 102,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Two",
    transform: "translate(49 86)",
    fill: "#29e67c",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.901,
    y: 0
  }, "Text"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "font_download_black_24dp",
    transform: "translate(26.442 16.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    "data-name": "Path 61963",
    d: "M0,0H45.035V45.035H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x37_4.TextSize",
    transform: "translate(-2.826 -38.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Text_3_",
    d: "M32.955,45.048H6.069A1.173,1.173,0,0,0,4.9,46.221v7.038a1.173,1.173,0,0,0,1.173,1.173H8.415a1.173,1.173,0,0,0,1.173-1.173V50.913h6.991V73.2H13.647a1.173,1.173,0,0,0-1.173,1.173V76.72a1.173,1.173,0,0,0,1.173,1.173h11.73A1.173,1.173,0,0,0,26.55,76.72V74.373A1.173,1.173,0,0,0,25.377,73.2H22.444V50.913h6.991v2.346a1.173,1.173,0,0,0,1.173,1.173h2.346a1.173,1.173,0,0,0,1.173-1.173V46.221A1.173,1.173,0,0,0,32.955,45.048Z",
    fill: "#29e67c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Text_2_",
    d: "M242.269,160.62h-17.4a.759.759,0,0,0-.759.759v4.556a.759.759,0,0,0,.759.759h1.519a.759.759,0,0,0,.759-.759v-1.519h4.525v14.427h-1.9a.759.759,0,0,0-.759.759v1.519a.759.759,0,0,0,.759.759h7.593a.759.759,0,0,0,.759-.759V179.6a.759.759,0,0,0-.759-.759h-1.9V164.417h4.525v1.519a.759.759,0,0,0,.759.759h1.519a.759.759,0,0,0,.759-.759v-4.556A.759.759,0,0,0,242.269,160.62Z",
    transform: "translate(-197.24 -103.988)",
    fill: "#29e67c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDrag);
export default __webpack_public_path__ + "static/media/Text_drag.588328f387b0c14c0cfd299df2ed0c69.svg";
export { ForwardRef as ReactComponent };